import { ToDo } from "../../Components/ToDo";
import { Step } from "../Step/Step";
import { Cash } from "../Step/Cash";
import { StepEvent, StepEventType } from "../Step/StepEvent";
import { StepType } from "../Step/StepType";
import { InvoiceStepState } from "./Models/InvoiceStepState";
import { InvoiceStepData } from "./Models/InvoiceStepData";
import { Table } from "@tblabs/truffle/Controls/TableBuilder/Table";
import { DateTimeProvider } from "../../Services/DateTimeProvider";


export class InvoiceStep extends Step<InvoiceStepState>
{
    public Type = StepType.Invoice;
    public Icon = "🗃️";
    public TitleForCustomer = () => `Faktura`;
    public Title = () => `Faktura`;

    public InitialState = InvoiceStepState.Preparing;
    public WellDoneStates = [InvoiceStepState.Sent];
    public FailedDoneStates = [];

    public get AsEvents(): StepEvent[]
    {
        return [
            new StepEvent(StepEventType.Invoice, this.Order.Id, "🗃️", "Faktura", this.Data.DeliveryDeadline.value, this.IsDone)
        ];
    }
    public get Mana(): Cash[]
    {
        return [];
    }
    public get WhenPlanned(): Date
    {
        return this.Data.DeliveryDeadline.value;
    }
    public get WhenDone(): Date
    {
        return this.Data.SentAt.value;
    }

    constructor(public Data: InvoiceStepData)
    {
        super(Data);
        this.IsVisibleForCustomer = false;
    }

    public STATES = {
        [InvoiceStepState.Preparing]: {
            StateName: "Przygotowywanie",
            Timeout: () => this.Data.DeliveryDeadline,
            Customer: {
                Content: () => [`Faktura jest właśnie przygotowywana`],
            },
            Admin: {
                Content: () => [`Faktura wymaga przygotowania`,
                    new Table().Class("payment-info-table")
                        .AddRow("Nazwa firmy", this.Data.CompanyName.value)
                        .AddRow("Adres", this.Data.CompanyAddress.value)
                        .AddRow("NIP", this.Data.CompanyNIP.value)
                        .AddRow("Kwota", "")
                        .AddRow("Tytułem", ""),
                    new ToDo(`Przygotuj dokument i wyślij do klienta na adres ${this.Data.CompanyEmail.value}`)],
                Actions: {
                    "✅": () => { this.Data.SentAt.value = DateTimeProvider.Now; this.GoTo(InvoiceStepState.Sent); },
                },
            },
        },
        [InvoiceStepState.Sent]: {
            StateName: "Wysłane",
            Admin: {
                Content: () => [`Faktura wysłana ✅`],
            }
        },
    };
}
